import { render, staticRenderFns } from "./SupplierViewProductsImport.vue?vue&type=template&id=4f8060aa"
import script from "./SupplierViewProductsImport.vue?vue&type=script&lang=js"
export * from "./SupplierViewProductsImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports